import "./src/styles/global.scss";
require("prismjs/themes/prism.css")
